import { recordPerformanceMetric } from "./recorder";
import type {
  PerformanceMetricAttributes,
  PerformanceMetricName,
  PerformanceOutcome,
} from "./types";

type TimerAttributes = Omit<
  PerformanceMetricAttributes,
  "durationMs" | "outcome" | "environment" | "shellVersion"
>;

export type PerformanceTimer = {
  complete: (outcome: PerformanceOutcome, extra?: Partial<TimerAttributes>) => void;
  cancel: () => void;
};

export function startPerformanceTimer(
  name: PerformanceMetricName,
  attributes: TimerAttributes,
): PerformanceTimer {
  const start = performance.now();
  let finished = false;

  const finish = (
    outcome: PerformanceOutcome,
    extra?: Partial<TimerAttributes>,
  ): void => {
    if (finished) {
      return;
    }
    finished = true;
    const durationMs = Math.max(0, performance.now() - start);
    recordPerformanceMetric(name, {
      ...attributes,
      ...extra,
      durationMs,
      outcome,
    });
  };

  return {
    complete: (outcome, extra) => {
      finish(outcome, extra);
    },
    cancel: () => {
      finish("cancelled");
    },
  };
}
